import { addBreadcrumb, setTag, setTags } from "@sentry/react";

import { DateTime } from "luxon";

// Which mechanism last kicked a session refresh. Read next to
// `auth.expires_at` on a Sentry event to tell "token died and nothing
// refreshed it" from "a refresh ran and the request still failed".
export type AuthRefreshSource =
  "timer" | "gate" | "catch-401" | "login" | "auth-id";

export function markAuthRefresh(source: AuthRefreshSource): void {
  const at = nowIso();
  setTags({
    "auth.last_refresh_at": at,
    "auth.last_refresh_source": source,
  });
  addBreadcrumb({
    category: "auth",
    level: "info",
    message: `session refresh (${source})`,
    data: { source, at },
  });
}

// Stamped when a session is successfully established. A stale value (weeks
// old) on an auth failure points at a dead Cognito refresh token rather than
// at the access-token refresh path.
export function markSessionStarted(): void {
  setTag("auth.session_started_at", nowIso());
}

function nowIso(): string {
  return DateTime.now().toUTC().toISO();
}
